import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import PureSponsor from './PureSponsor'
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

class TableSponsor extends React.Component {
  constructor(props){
      super(props);
      this.state = {
      }
    }

    renderSponsor = () => {
      return (
        this.props.sponsor.map((sponsor, index) => (
        <PureSponsor  sponsorSelect={this.props.SponsorSelect} refParent={this.props.refParent} sponsor={sponsor} key={sponsor.Id} index={index}/>
      ))
      )
    }

 render() {
   return (
     <Table>
      {
        this.props.sponsor.length === 0 ?
        <TableBody>
          <TableRow>
            <TableCell  colSpan={"5"}>
              <Container fluid>
                <Row>
                  <Col xl={12} lg={12} md={12} sm={12} style={{display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 3}}>
                    <p style={{color: 'black', fontSize: '1.2rem', fontWeight: 'bold'}}>Pas de résultat</p>
                  </Col>
                </Row>
              </Container>
            </TableCell>
          </TableRow>
        </TableBody>
        :
        <TableBody>
          {this.renderSponsor()}
        </TableBody>
      }

    </Table>
   )
 }
}


export default TableSponsor;
